import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import JobPlanActivityTable from "./JobPlanActivityTable";

import ActivityFormDialog from "./ActivityForm/ActivityFormDialog";
import ConfirmDialog from "../../Common/Dialog/ConfirmDialog";

import { deleteJobPlanActivity } from "../../../actions/jpActions";

import { getDayOfWeek } from "./functions";


const getActivityLabel = (activity) => {
    let label = activity.subcategory.name;
    if (!activity.flexible) {
        label = `${label} (${getDayOfWeek(activity.scheduled.dayOfWeek)} ${activity.scheduled.start} - ${activity.scheduled.end})`;
    }
    return label;
}

function JobPlanActivityList({ title, activities, jpId, isCompleted }) {
    const dispatch = useDispatch();
    let categoryCollection = [];
    let categories = [];
    let durationUnit = "PA";

    const [selected, setSelected] = useState(null);
    const [openDialog, setOpenDialog] = useState(null);

    activities.forEach((activity) => {
        if (categoryCollection[activity["category"]["name"]]) {
            categoryCollection[activity["category"]["name"]].activities.push(activity);
        } else {
            categoryCollection[activity["category"]["name"]] = {
                activities: [],
                heading: activity["category"]["name"] + " (" + activity["category"]["code"] + ")",
            };
            categoryCollection[activity["category"]["name"]].activities.push(activity);
        }
    });

    for (const prop in categoryCollection) {
        categories.push(categoryCollection[prop]);
    }

    return (
        <Card className="card">
            <CardHeader
                disableTypography={true}
                title={
                    <Typography component="h3" className="card-header-title">
                        {title}
                    </Typography>
                }
            />
            {categories?.length > 0 && categories.map((category, index) => (
                <CardContent key={index}>
                    <Box className="card-content">
                        <JobPlanActivityTable
                            activities={category.activities}
                            jpId={jpId}
                            isCompleted={isCompleted}
                            onEdit={((activity) => {
                                setSelected(activity);
                                setOpenDialog('edit');
                            })}
                            onDelete={((activity) => {
                                setSelected(activity);
                                setOpenDialog('delete');
                            })}
                            heading={category.heading}
                            subheading=""
                            durationUnit={durationUnit}
                            workingWeeks={44}
                        />
                    </Box>
                </CardContent>
            ))}
            {!!selected && openDialog === 'edit' && (
                <ActivityFormDialog
                    open
                    jpId={jpId}
                    data={selected}
                    onClose={() => {
                        setSelected(null);
                        setOpenDialog(null);
                    }}
                />
            )}
            {!!selected && openDialog === 'delete' && (
                <ConfirmDialog
                    open
                    title="Remove activity"
                    content={`Remove ${getActivityLabel(selected)}?`}
                    confirmButtonLabel="Remove"
                    onClose={() => setSelected(null)}
                    onCancel={() => setSelected(null)}
                    onConfirm={() => dispatch(deleteJobPlanActivity('P-JP', selected.id, jpId))}
                />
            )}
        </Card>
    );
}

export default JobPlanActivityList;
